import bookingQuoteResponse from "@/state/bookingQuoteResponse"
import bookingQuoteResponse_edit from "@/state/bookingQuoteResponse_edit"
import { QuoteResponseDTO } from "../../../requests-module/src"

export const setBookingQuoteResponse = (response: QuoteResponseDTO | null) => {
    const validUser = response?.validUser || bookingQuoteResponse.value?.validUser
    bookingQuoteResponse.value = response ? {...response, validUser } : null;
    bookingQuoteResponse_edit.value = response ? {...response, validUser} : null;
}